import {CREATE_ERROR_SUCCESS} from "../../../reducers/editErrorReducer";


export const createErrorSuccess = (errors) =>{
    return {
        type: CREATE_ERROR_SUCCESS,
        payload: {errors}
    }
}